import { css } from 'styled-components';
import { ButtonProps } from '@mui/material';
import { componentToken } from '../../style/utils';
import { ButtonSize } from './types';

type StyleProps = ButtonProps & { $size?: ButtonSize };

const sizeKey = ($size?: ButtonSize) =>
  $size === 'extraSmall' || $size === 'large' ? $size : 'medium';

const buttonStyles = css<StyleProps>`
  text-transform: none;
  box-shadow: none;
  font-weight: ${({ theme, $size }) =>
    theme.tokens.components.button.size[sizeKey($size)].fontWeight};
  font-size: ${({ theme, $size }) =>
    theme.tokens.components.button.size[sizeKey($size)].fontSize};
  height: ${({ theme, $size }) =>
    theme.tokens.components.button.size[sizeKey($size)].height};
  padding: ${({ theme, $size }) =>
    theme.tokens.components.button.size[sizeKey($size)].padding};
  border-radius: ${componentToken('button.radius')};
  white-space: nowrap;

  &:hover {
    box-shadow: none;
  }

  :disabled {
    svg > path {
      fill: ${componentToken('button.disabledIcon')};
    }
  }

  ${({ theme, variant, color }) => {
    const { contained, outlined, text } = theme.tokens.components.button;
    if (variant === 'contained') {
      if (color === 'primary') {
        return `
          background: ${contained.primary.bg};
          color: ${contained.primary.fg};
          border: none;
          :disabled {
            background: ${contained.primary.disabledBg};
            color:  ${contained.primary.disabledFg};
          }
        `;
      }
      if (color === 'secondary') {
        return `
          background: ${contained.secondary.bg};
          border: none;
          color: ${contained.secondary.fg};
          :hover {
            background: ${contained.secondary.hoverBg};
          }
          :disabled {
            background: ${contained.secondary.disabledBg};
            color:  ${contained.secondary.disabledFg};
          }
        `;
      }
      if (color === 'error') {
        return `
          background: ${contained.error.bg};
          border: none;
          color: ${contained.error.fg};
          :hover {
            background: ${contained.error.hoverBg};
            filter: brightness(110%);
          }
        `;
      }
    }

    if (variant === 'outlined') {
      if (color === 'primary') {
        return `
          background:  ${outlined.primary.bg};
          border-color: ${outlined.primary.border} ;
          color: ${outlined.primary.fg};
          :hover {
            background: ${outlined.primary.hoverBg};
            border-color: ${outlined.primary.hoverBorder} ;
          }
          :disabled {
            background: ${outlined.primary.disabledBg};
            color:  ${outlined.primary.disabledFg};
          }
        `;
      }
      if (color === 'secondary') {
        return `
          background:  ${outlined.secondary.bg};
          border-color: ${outlined.secondary.border};
          color: ${outlined.secondary.fg};
          :hover {
            border-color: ${outlined.secondary.hoverBorder};
            background: ${outlined.secondary.hoverBg};
          }
        `;
      }
    }

    if (variant === 'text') {
      if (color === 'primary') {
        return `
          background: none;
          border: none;
          :hover {
            background: none;
          }
      `;
      }
      if (color === 'secondary') {
        return `
        background: none;
        border: none;
        color:  ${text.secondary.fg};
        :hover {
          background: none;
        }
    `;
      }
    }

    return ``;
  }}
`;

export default buttonStyles;
